import React, { Component } from 'react'
import FBLoginUI from './FBLoginUI.js'

class FBLoginSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  render() {
    return (
      <FBLoginUI
        context={this.props.context}
        messageList={this.props.messageList}
        onClick={this.onClick}
      />
    )
  }

  onClick = (event) => {
    event.preventDefault()
    window.location = this.props.socialLoginUrl.fbLoginUrl
  }
}

export default FBLoginSF
